module.exports = __webpack_public_path__ + "static/media/avg-time.819c6e05.svg";